export default __webpack_public_path__ + "static/media/cart.8b70f067.svg";